import UsersScreenContextProvider from '../../context/users/UsersScreenContextProvider';
import MainPage from './components/MainPage';

function Operations() {
  return (
    <UsersScreenContextProvider>
      <MainPage />
    </UsersScreenContextProvider>
  );
}

export default Operations;
